import {Message} from 'element-ui'

// 判断是否为空对象
export function isEmptyObject (obj) {
  for (let n in obj) { return false }
  return true
}

// json树形数据转换成平级数据
export function flatJson ({ id, name, children, checked }, result = [], pId = '') {
  result = [{id, name, checked, pId}]
  if (Array.isArray(children) && children.length) {
    children.reduce((result, data) => {
      result.splice(0, 0, ...flatJson(data, result, id))
      return result
    }, result)
  }
  return result
}

// json平级数据转换成树形数据
export function treeJson (data) {
  // 删除 所有 children,以防止多次调用
  data.forEach(function (item) {
    delete item.children
  })
  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  let map = {}
  data.forEach(function (item) {
    map[item.treeId] = item
  })
  //        console.log(map);
  let val = []
  data.forEach(function (item) {
    // 以当前遍历项，的pid,去map对象中找到索引的id
    let parent = map[item.parentTreeId]
    // 好绕啊，如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      (parent.children || (parent.children = [])).push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      val.push(item)
    }
  })
  return val
}

// 获取距离当前的天数 2019-03-26
export function daysDistance (date) {
  if (!date) {
    return ''
  }
  let date1 = Date.parse(date)
  // 获取年月日
  let time = new Date()
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let day = time.getDate()
  // 检查是否小于10
  month = check(month)
  day = check(day)
  let date2 = Date.parse(year + '-' + month + '-' + day)
  let distance = Math.abs(date2 - date1)
		console.log(Math.floor(distance / (24 * 3600 * 1000)))
  return Math.floor(distance / (24 * 3600 * 1000))

}

export function check (i) {
  let num
  i < 10 ? num = '0' + i : num = i
  return num
}

// 校验规则
// 非中文输入
/**
 * @return {boolean}
 */
export function NonChineseInput (value, message, warn, customClass) {
  let regExp = /[\u4E00-\u9FA5\uF900-\uFA2D]/
  if (regExp.test(value)) {
    Message({
      message: warn,
      type: 'warning',
      customClass: 'login-error',
      duration: 1000
    })
    return false
  } else if (value === '' || value === null || value === undefined) {
    Message({
      message: message,
      type: 'warning',
      customClass: customClass,
      duration: 1000
    })
    return false
  } else {
    return true
  }
}
// 输入不为空
export function noEmpty (value, message, customClass) {
  if (value === '' || value === null || value === undefined) {
    Message({
      message: message,
      type: 'warning',
      customClass: customClass,
      duration: 1000
    })
    return false
  } else {
    return true
  }
}

// 输入正整数
export function positiveInteger (value, message, customClass) {
  let regExp = /^[1-9]\d*$/
  console.log(value)
  console.log(regExp.test(value))
  if (value === '' || value === null || value === undefined || !regExp.test(value)) {
    Message({
      message: message,
      type: 'warning',
      customClass: customClass,
      duration: 1000
    })
    return false
  } else {
    return true
  }
}

// 2019-07-24T08:53:28.000+0000 转换
export function renderTime (date) {
  let dateee = new Date(date).toJSON()
  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
}

// 2019-07-24T08:53:28.000+0000 转换
export function changeTime (date) {
  return date.substring(0, 10)
}

// 两个日期相差的天数
export function reduceDate (start, end) {
  let startDate = new Date(start)
  let endDate = new Date(end)
  return Math.ceil((endDate.getTime() - startDate.getTime()) / 86400000)
}

// 获取字符的长度
export function stringLength (test) {
  // eslint-disable-next-line no-unused-vars
  let len = 0
  let code = 0
  for (let i = 0; i < test.length; i++) {
    code = test.charCodeAt(i)
    if (code >= 0 && code <= 127) {
      len += 1
    } else {
      len += 2
    }
  }
}

export function getDay (day) {
  var today = new Date()

  let targetday = today.getTime() + 1000 * 60 * 60 * 24 * day

  today.setTime(targetday) // 注意，这行是关键代码

  var tYear = today.getFullYear()

  var tMonth = today.getMonth()

  var tDate = today.getDate()

  tMonth = doHandleMonth(tMonth + 1)

  tDate = doHandleMonth(tDate)

  return tYear + '-' + tMonth + '-' + tDate
}

export function doHandleMonth (month) {
  var m = month

  if (month.toString().length === 1) {
    m = '0' + month
  }

  return m
}

// 获取日期
export function getDate (body) {
  const dt = new Date()

  const y = dt.getFullYear()
  let M = (dt.getMonth() + '').padStart(2, '0')
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  let d = (dt.getDate() + '').padStart(2, '0')
  console.log(y+"-"+m+"-"+d)
  console.log(y+"-"+M+"-"+d)
  if (body) {
    return `${y}-${m}-${d}`
  } else {
    if (M === '00') {
      M = '12'
      return `${y-1}-${M}-${d}`
    }else if(M==='02'){
      if (((y % 4)==0) && ((y % 100)!=0) || ((y % 400)==0)) {
            if(d>='30'){
              d='29'
              return `${y}-${M}-${d}`
            }
        }else{
          if(d>='29'){
            d='28'
            return `${y}-${M}-${d}`
          }
        } 
    }else{
      return `${y}-${M}-${d}`
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/tools/methods.js